import { Fragment } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

import { ControlesLinha } from '../../components/RelatorioCivelComponents';
import { filtrarOpcoesTipoRecurso } from '../../utils/tipo-recurso-options.utils';

import type { NaturezaAcaoOption } from '../relatorio-civel-page.models';
import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step09Recursos(props: RelatorioCivelStepProps) {
  const {
    novoProcessoRecursos,
    setNovoProcessoRecursos,
    novoTipoRecurso,
    setNovoTipoRecurso,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    apenasNumeros,
    naturezaAcaoOptions,
    renderTabelaProcessos,
  } = props;

  const tipoRecursoOptions = filtrarOpcoesTipoRecurso(naturezaAcaoOptions);

  const handleAdicionar = () => {
    adicionarProcesso('recursos', novoProcessoRecursos, setNovoProcessoRecursos, {
      tipoRecurso: novoTipoRecurso,
      setTipoRecurso: setNovoTipoRecurso,
    });
  };

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ex: 000000.000.000"
                value={novoProcessoRecursos}
                onChange={(e) => setNovoProcessoRecursos(apenasNumeros(e.target.value))}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    handleAdicionar();
                  }
                }}
              />
            </Form.Group>
          </Col>
          <Col md={5}>
            <Form.Group>
              <Form.Label className="fw-bold">Tipo Recurso</Form.Label>
              <Select
                classNamePrefix="react-select"
                value={tipoRecursoOptions.find((o: NaturezaAcaoOption) => o.value === novoTipoRecurso) || null}
                onChange={(option) => setNovoTipoRecurso(option ? (option as NaturezaAcaoOption).value : '')}
                options={tipoRecursoOptions}
                placeholder="Digite para buscar..."
                isClearable
                isDisabled={isViewMode}
              />
            </Form.Group>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <Button variant="primary" onClick={handleAdicionar} className="w-100" style={{ borderRadius: '8px' }}>
              <i className="bi bi-plus-lg me-2"></i>
              Adicionar
            </Button>
          </Col>
        </Row>
      )}
      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.recursos}
          onDecrementar={() => setQuantidadeLinhas((prev) => ({ ...prev, recursos: Math.max(1, prev.recursos - 1) }))}
          onIncrementar={() => setQuantidadeLinhas((prev) => ({ ...prev, recursos: Math.min(50, prev.recursos + 1) }))}
          onQuantidadeChange={(value: number) => setQuantidadeLinhas((prev) => ({ ...prev, recursos: value }))}
          onAdicionar={() => adicionarMultiplasLinhas('recursos')}
          totalLabel="Total de Processos"
          totalCount={formData.recursos.processos.length}
        />
      )}
      {renderTabelaProcessos('recursos', formData.recursos.processos)}
    </Fragment>
  );
}
